module.exports = __webpack_public_path__ + "static/media/19-10.67a37d9b.mp3";